import { render, staticRenderFns } from "./BookingNumber.vue?vue&type=template&id=afae6d4e&"
import script from "./BookingNumber.vue?vue&type=script&lang=js&"
export * from "./BookingNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports